<script setup>
import { computed } from 'vue'
import { SwitchRoot, useForwardPropsEmits } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  defaultChecked: { type: Boolean, required: false },
  checked: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  required: { type: Boolean, required: false },
  name: { type: String, required: false },
  id: { type: String, required: false },
  value: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})

const emits = defineEmits(['update:checked'])

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <SwitchRoot v-bind="forwarded" :class="['form-check-input', props.class]" />
</template>
